import { Component } from '@angular/core';

@Component({
    selector: 'app-quick-view',
    templateUrl: './quick-view.component.html',
    standalone: false
})



export class QuickViewComponent {

}

